import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, Slide, AppBar, Toolbar, IconButton, Typography, Paper, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  GridRowModes,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import FundingCostGrid from './FundingCostGrid';
import FieldNames from "../../../defaults/FieldNames.json";
import ColorConstants from '../../../defaults/ColorConstants';
export default function CostsFundingPopover({open, onClose, userInfo, isTreatment, isActual, editableFeature, setBaseFeatureAttributes, setEditableFeature,
  mode, userRoleInfo, isApproved, rederiveFeatureInfo, setLocationDepartmentValue, setLocationAgencyValue, setLocationRegionValue, 
  setLocationUnitValue, featureUnsavedFields }) {
  return (
    <Dialog
      style={{ minWidth: 550 }}
      onClose={onClose}
      fullScreen
      //TransitionComponent={Transition}
      open={open}
      className="dialog-modal">
      <AppBar sx={{ position: 'relative' }} style={{backgroundColor: ColorConstants.BlueAlien}}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon style={{ fill: ColorConstants.WhiteAlien }} />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" style={{ color: ColorConstants.WhiteAlien }}>
            {(mode === FieldNames.modes.edit && !isApproved) && 
              <span>Manage Costs</span>
            }
            {(mode !== FieldNames.modes.edit || (mode === FieldNames.modes.edit && isApproved)) && 
              <span>View Costs</span>
            }
          </Typography>
        </Toolbar>
      </AppBar>
      <FundingCostGrid editableFeature={editableFeature} setEditableFeature={setEditableFeature} userInfo={userInfo} mode={mode} 
                userRoleInfo={userRoleInfo} isApproved={isApproved} rederiveFeatureInfo={rederiveFeatureInfo} 
                setLocationDepartmentValue={setLocationDepartmentValue} setLocationAgencyValue={setLocationAgencyValue}
                setLocationRegionValue={setLocationRegionValue} setLocationUnitValue={setLocationUnitValue}
                featureUnsavedFields={featureUnsavedFields} setBaseFeatureAttributes={setBaseFeatureAttributes}
      />
    </Dialog>
  );
}